import React from "react"

import { Seperator } from "../../components/common/seperator/seperator"
import { RequestCall } from "./RequestCall"

interface Props {
  dealershipGuidError: boolean
  errorForNoDealershipGuid: (props: any) => void
}

const NoValuationProvided: React.FC<Props> = ({
  dealershipGuidError,
  errorForNoDealershipGuid,
}) => {
  return (
    <>
      <div className="inner-container no-valuation-provided">
        <Seperator />
        <h2 className="appointment-heading">Valuation requested</h2>
        <p className="appointment-paragraph">
          Sorry we can't provide an instant valuation, we appear to have
          encountered a problem. Request a call and one of our team can help get
          you a valuation over the phone.
        </p>
        <RequestCall
          dealershipGuidError={dealershipGuidError}
          errorForNoDealershipGuid={errorForNoDealershipGuid}
        />
      </div>
    </>
  )
}

export default NoValuationProvided
